<template>
  <div>
    <img
      class="icon-8x margin-top-10x text-center margin-left-22x"
      :src="uploadpath + 'resource/' + Res.login_logo"
      alt=""
    />
    <div class="flex-column margin-left-5x">
      <input
        class="f-g2 h2 border-none margin-top-8x"
        placeholder="请输入手机号"
        maxlength="11"
        v-model="mobile"
      />
      <div
        class="flex-column margin-top-3x margin-right-7x bg-g4 height-1"
      ></div>
      <div class="flex-row justify-between margin-right-7x margin-top-8x">
        <input
          class="f-g2 h2 border-none"
          v-model="verifycode"
          maxlength="6"
          placeholder="请输入验证码"
        />
        <div class="bg-g8 border-25x" style="padding:5px 16px">
          <span
          class="f-s1 f-24" 
          @click="sendverifycode"
          :disabled="mobile.length != 11 || mobile[0] != '1'"
          v-show="show"
          >获取验证码</span
        >
        <span class="margin-left f-20" v-show="!show">{{ count }}s后重新获取</span>
        </div>
        
      </div>
      <div
        class="flex-column margin-top-3x margin-right-7x bg-g4 height-1"
      ></div>
      <button
        class="
          wrap4
          border-10x
          f-w h2
          border-none
          margin-top-10x margin-right-7x
        "
        style="background: linear-gradient(-3deg, #9D9B2A 0%, #B8B62D 100%);"
        @click="login"
      >
        登录
      </button>
    </div>
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";
import { Toast } from "vant";
import { touchstart } from "dom7";

export default {
  inject: ["reload"], //原来导入App.vue中的刷新方法
  data() {
    return {
      Res: {},
      Inst: {},
      Member: null,
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
      mobile: "",
      show: true,
      count: "",
      timer: null,
      verifycode:''
    };
  },
  created() {
    PageHelper.Init(this);
  },
  methods:{
    sendverifycode() {
      if(this.mobile==''){
        Toast.fail("请输入手机号");
      }else{
        HttpHelper.Post("sms/test", {
        mobile: this.mobile,
      }).then((ret) => {
        if (ret.code == 0) {
          Toast.success("短信已发送，请注意查收");
        } else {
          Toast.fail("发送失败，请稍后重试");
        }
      });
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
      }
      
    },
    login() {
      let that=this;
      HttpHelper.Post("member/verifycode", {
        mobile: this.mobile,
        verifycode: this.verifycode,
      }).then((ret) => {
        console.log(ret)
        if (ret.code == 0) {
          // HttpHelper.Post("login/notelogin", {
          //   mobile: this.mobile,
          // }).then((ret) => {
          //   if (ret.code == 0) {
            console.log(this.Member)
              window.localStorage.setItem("token", ret.return);
              window.localStorage.setItem("mobile", that.mobile);
              Toast.success("登录成功！");

              this.routeto("/");
              
              // this.routeto("/");
            // } else if (ret.code == -1) {
            //   Toast.fail("手机号不存在，请先注册！");
            //   // this.routeto("/register")
            // }
          // });
        } else {
          Toast.fail("验证码错误");
        }
      });
    },
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Login.vue